var _g, _path, _g2, _path2, _path3, _g3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUntracked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_428_36061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4098 7.3076H11.1266V6.46239C11.1266 6.23823 11.0376 6.02325 10.8791 5.86474C10.7206 5.70624 10.5056 5.61719 10.2814 5.61719H6.90062C6.67646 5.61719 6.46148 5.70624 6.30297 5.86474C6.14446 6.02325 6.05542 6.23823 6.05542 6.46239V7.3076H5.76805C5.73218 7.3076 5.69778 7.32185 5.67242 7.34721C5.64706 7.37257 5.63281 7.40697 5.63281 7.44284V8.44018C5.63281 8.51498 5.69324 8.57541 5.76805 8.57541H6.05542V11.111C6.05542 11.3435 6.05542 11.5336 6.47802 11.5336V12.1675C6.47802 12.2236 6.50028 12.2773 6.53991 12.317C6.57953 12.3566 6.63328 12.3788 6.68932 12.3788H7.53452C7.59057 12.3788 7.64431 12.3566 7.68394 12.317C7.72356 12.2773 7.74583 12.2236 7.74583 12.1675V11.5336H9.43624V12.1675C9.43624 12.2236 9.4585 12.2773 9.49812 12.317C9.53775 12.3566 9.5915 12.3788 9.64754 12.3788H10.4927C10.5488 12.3788 10.6025 12.3566 10.6422 12.317C10.6818 12.2773 10.704 12.2236 10.704 12.1675V11.5336C11.1266 11.5336 11.1266 11.3435 11.1266 11.111V8.57541H11.4098C11.4468 8.57541 11.4822 8.56072 11.5084 8.53457C11.5346 8.50841 11.5492 8.47294 11.5492 8.43595C11.5492 8.39897 11.5346 8.3635 11.5084 8.33734C11.4822 8.31119 11.4468 8.29649 11.4098 8.29649C11.3728 8.29649 11.3373 8.31119 11.3112 8.33734C11.285 8.3635 11.2703 8.39897 11.2703 8.43595C11.2703 8.47294 11.285 8.50841 11.3112 8.53457C11.3373 8.56072 11.3728 8.57541 11.4098 8.57541C11.4468 8.57541 11.4822 8.56072 11.5084 8.53457C11.5346 8.50841 11.5492 8.47294 11.5492 8.43595V7.44706C11.5492 7.41007 11.5346 7.3746 11.5084 7.34845C11.4822 7.3223 11.4468 7.3076 11.4098 7.3076ZM7.74583 6.03979H9.43624V6.46239H7.74583V6.03979ZM6.90062 10.6884C6.78854 10.6884 6.68105 10.6439 6.6018 10.5647C6.52254 10.4854 6.47802 10.3779 6.47802 10.2658C6.47802 10.1537 6.52254 10.0463 6.6018 9.967C6.68105 9.88775 6.78854 9.84322 6.90062 9.84322C7.0127 9.84322 7.12019 9.88775 7.19945 9.967C7.2787 10.0463 7.32322 10.1537 7.32322 10.2658C7.32322 10.3779 7.2787 10.4854 7.19945 10.5647C7.12019 10.6439 7.0127 10.6884 6.90062 10.6884ZM6.47802 8.99802V6.885H10.704V8.99802H6.47802ZM10.2814 10.6884C10.1694 10.6884 10.0619 10.6439 9.98262 10.5647C9.90336 10.4854 9.85884 10.3779 9.85884 10.2658C9.85884 10.1537 9.90336 10.0463 9.98262 9.967C10.0619 9.88775 10.1694 9.84322 10.2814 9.84322C10.3935 9.84322 10.501 9.88775 10.5803 9.967C10.6595 10.0463 10.704 10.1537 10.704 10.2658C10.704 10.3779 10.6595 10.4854 10.5803 10.5647C10.501 10.6439 10.3935 10.6884 10.2814 10.6884Z",
    fill: "#F6A300"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_36061",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57738 8.3552L1.47495 8.41317L0.0869377 5.42077L11.7734 0L14.6745 6.25438L5.67038 10.4309L4.73253 8.40905L3.57738 8.3552Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_36061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.20972 11.5108C2.54644 10.0808 2.47837 8.4459 3.02049 6.96574C3.56262 5.48558 4.67053 4.28141 6.10049 3.61812C7.53046 2.95483 9.16535 2.88676 10.6455 3.42889C12.1257 3.97101 13.3298 5.07892 13.9931 6.50889",
    stroke: "#F6A300",
    strokeWidth: 0.950959
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20239 8.39991L2.7282 10.9854L4.20442 8.37128L1.20239 8.39991Z",
    fill: "#F6A300"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_428_36061",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 16,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6179 9.6448L15.7204 9.58683L17.1084 12.5792L5.42188 18L2.5208 11.7456L11.5249 7.56906L12.4628 9.59095L13.6179 9.6448Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_428_36061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9856 6.48924C14.6489 7.91921 14.7169 9.5541 14.1748 11.0343C13.6327 12.5144 12.5248 13.7186 11.0948 14.3819C9.66485 15.0452 8.02997 15.1132 6.54981 14.5711C5.06966 14.029 3.86549 12.9211 3.2022 11.4911",
    stroke: "#F6A300",
    strokeWidth: 0.950959
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9851 9.60009L14.4593 7.01457L12.9831 9.62872L15.9851 9.60009Z",
    fill: "#F6A300"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_428_36061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.76164,
    height: 6.76166,
    fill: "white",
    transform: "translate(5.21094 5.61719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUntracked);
export default __webpack_public_path__ + "static/media/untracked.ad11b8090fb6c502443e2161d712e9bb.svg";
export { ForwardRef as ReactComponent };